module.exports = __webpack_public_path__ + "static/media/black-voting-box.7f7651d2.jpg";